export default "__VITE_ASSET__BeWsWTHz__"